import {
  CardProps,
  Box,
  CardContent,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { EmptyValueBars } from "../item/EmptyValueBars";

const useStyles = makeStyles((theme) => ({
  skeleton: {
    "margin-right": theme.spacing(6),
  },
  empty: {
    "&:not(:last-child)": {
      paddingRight: theme.spacing(3),
    },
  },
  goals: {
    display: "grid",
    gridTemplateColumns: "repeat(1, 1fr)",
    marginTop: theme.spacing(4.5),

    [theme.breakpoints.up("sm")]: {
      gridTemplateColumns: "repeat(2, 1fr)",
    },

    [theme.breakpoints.up("md")]: {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
  },
}));

export interface ClientGoalsCardSkeletonProps extends CardProps {}

export function ClientGoalsCardSkeleton(props: ClientGoalsCardSkeletonProps) {
  const s = useStyles();
  const { breakpoints } = useTheme();

  const isSm = useMediaQuery(breakpoints.only("sm"));
  const isMdUp = useMediaQuery(breakpoints.up("md"));

  const skeletonCount = isSm ? 2 : isMdUp ? 3 : 1;

  return (
    <>
      <CardContent
        sx={{ "&.MuiCardContent-root": { padding: "0 !important" } }}
      >
        <Box className={s.goals}>
          {Array.from({ length: skeletonCount }).map((_, i) => (
            <EmptyValueBars key={i} className={s.empty} />
          ))}
        </Box>
      </CardContent>
    </>
  );
}
